/* @flow strict */

import * as React from 'react';
import Switcher from '/client/src/components/switcher';
import { PUT } from '/client/src/api';
import CssPinner from '/client/src/components/csspinner';

/* eslint-disable camelcase */

export const columns = (eventId: number | string): [] => [
  {
    selector: 'is_disabled',
    name: 'on/off',
    sortable: false,
    cell: (row: {}): React.Element<'div'> => (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between'
        }}
      >
        <Switcher
          className='form-switcher-sm'
          id={row.id}
          name={row.id.toString()}
          index={row.id}
          checked={!row.is_disabled}
          onCallback={async (e: any, newStatus: boolean) => {
            CssPinner(document.querySelector('.EventDetailContainer .panel-body'), true);
            try {
              await PUT(`/api/v1/1/sponsors/event/${eventId}/${row.id}/${newStatus ? 'enable' : 'disable'}`);
              CssPinner(document.querySelector('.EventDetailContainer .panel-body'), false);
            } catch (error) {
              CssPinner(document.querySelector('.EventDetailContainer .panel-body'), false);
            }
          }}
        />
      </div>
    )
  },
  {
    selector: 'sponsor_name',
    name: 'Name',
    sortable: true
  }
  // {
  //   selector: 'email',
  //   name: 'Email'
  // }
];
